import { formatReminderDate, formatTime } from "./date";
import { normalizePhone } from "./search";
import type { Appointment, Owner, Pet } from "../types";

export function buildReminderMessage(owner: Owner, pet: Pet, appointment: Appointment) {
  const firstName = owner.fullName.trim().split(/\s+/)[0] || owner.fullName;
  return `Dzień dobry, ${firstName}! Przypominamy o wizycie ${pet.name}: ${formatReminderDate(appointment.startsAt)} o ${formatTime(appointment.startsAt)}. Prosimy o potwierdzenie. Do zobaczenia! 🐾`;
}

export function buildReminderLinks(owner: Owner, pet: Pet, appointment: Appointment) {
  const message = buildReminderMessage(owner, pet, appointment);
  const encodedMessage = encodeURIComponent(message);
  const phone = normalizePhone(owner.phone);
  const subject = encodeURIComponent(`Przypomnienie o wizycie ${pet.name}`);

  return {
    sms: `sms:+${phone}?body=${encodedMessage}`,
    whatsapp: `https://wa.me/${phone}?text=${encodedMessage}`,
    email: owner.email ? `mailto:${owner.email}?subject=${subject}&body=${encodedMessage}` : undefined,
  };
}
